<template>
	<div class = "whole-viewport">
		<v-toolbar color = "blue-grey lighten-5" class = "index-topbar">
			<v-hover>
				<img slot-scope="{ hover }" src="../assets/logo-fine.png" alt = "music x lab logo" class = "logo"  />
			</v-hover>
      <div style="width: 30px"></div>
			<v-hover>
				<img slot-scope="{ hover }" src="../assets/logo-nyu.png" alt = "music x lab logo" class = "logonyu"/>
			</v-hover>
      <div style="width: 30px"></div>
      <v-hover>
				<img slot-scope="{ hover }" src="../assets/logo-mbzuai.png" alt = "mbzuai logo" class = "logombz"/>
			</v-hover>
    		<!-- <v-toolbar-title>Music X Lab</v-toolbar-title> -->
    		<v-spacer></v-spacer>
    		<v-toolbar-items  style="font-family:'Breve Display';">
      			<v-btn flat :color= "this.$color.primary" style="font-size:1.2rem;" @click =" $router.push({path:'/index'})">Home</v-btn>
      			<v-btn flat :color= "this.$color.primary" style="font-size:1.2rem;"  @click =" $router.push({path:'/people'})">People</v-btn>
				<v-menu offset-y open-on-hover>
					<template v-slot:activator = "{on}">
        				<v-btn color= "#575757" flat v-on = "on" style="font-size:1.2rem;" @click =" $router.push({path:'/groups'})">Groups</v-btn>
					</template>
      				<v-list>
        				<v-list-tile v-for="(item, index) in groupInfo" :key = "index" @click="$router.push({name:'Groups',params:{logan:item.logan}})" >
          					<v-list-tile-title>
								{{ item.name }}
							</v-list-tile-title>
        				</v-list-tile>
      				</v-list>
				</v-menu>
                <v-menu offset-y open-on-hover>
					<template v-slot:activator = "{on}">
        				<v-btn color= "#657C88" flat v-on = "on" style="font-size:1.2rem;">Demos</v-btn>
					</template>
      				<v-list>
        				<v-list-tile v-for="(item, dindex) in demoInfo" :key = "dindex" @click="$router.push({path: item.address})" >
          					<v-list-tile-title >
								{{ item.name }}
							</v-list-tile-title>
        				</v-list-tile>
                        <v-list-tile flat @click="switchToPage('https://www.cs.cmu.edu/~gxia/demo.html')"><v-list-tile-title >Other Demos</v-list-tile-title></v-list-tile>
      				</v-list>
                    
				</v-menu>
				
				<v-btn :color= "this.$color.primary" flat style="font-size:1.2rem;" @click =" $router.push({path:'/publications'})">Publications</v-btn>
				<v-btn :color= "this.$color.primary" flat style="font-size:1.2rem;" @click =" switchToPage('http://blog.musicxlab.com/') ">Blog</v-btn>
				<v-btn :color= "this.$color.primary" flat style="font-size:1.2rem;" @click =" switchToPage('https://github.com/music-x-lab/music-x-lab') ">Github</v-btn>
				<!-- <v-btn flat>News</v-btn> -->
    		</v-toolbar-items>
  		</v-toolbar>
        <title>Interactive Rainbow Score: An Interactive Visual System for Flute Performance Tutoring</title>
        <div class='cover'>
        <h1>
        <p class='text-center'>
            Interactive Rainbow Score: An Interactive Visual System <br />
            for Flute Performance Tutoring 
        </p></h1>
        <img src='../assets/demo_irs/gif.gif' alt='GIF showing the visual interface in action.' />
        </div>
        <div><p class='oneline-p'>
        <span class='iv-backcolor' @click="clickSpan('iv');">Interactive visual feedback</span>
        improves
        <span class='sp-backcolor' @click='clickSpan("sp");'>sight-playing</span>
        learning rate by 
        <span class='exp-backcolor' @click='clickSpan("exp");'>31.1%</span>.
        </p></div>

        <div class='para-div sp-backcolor' id='sp'>
        <p class='heading'>
            <b>Sight-playing</b>
        </p>
        <p>
            The ability to read a new music score (never seen before) and perform it on the fly. 
        </p>
        <p>
            Contrary to most <a href='http://www.nime.org/proceedings/2019/nime2019_paper028.pdf'>computer-aided music learning studies</a>, where the learner learns to perform a specific piece by memorizing it (type I musical skill), this study focuses on a general musical skill applicable to any music (type II musical skill). 
        </p>
        <p>
            <img src='../assets/demo_irs/sp.png' alt='A triangle of Audio, Visual, and Motor. Information flows from Visual to Motor.'/>
        </p>
        </div>
        <div><p class='oneline-p'>
        <span class='iv-backcolor' @click='clickSpan("iv")'>Interactive visual feedback</span>
        improves
        <span class='sp-backcolor' @click='clickSpan("sp")'>sight-playing</span>
        learning rate by 
        <span class='exp-backcolor' @click='clickSpan("exp")'>31.1%</span>.
        </p></div>

        <div class='para-div iv-backcolor' id='iv'>
        <p class='heading'>
            <b>Interactive Visual Feedback</b>
        </p>
        <p>
            Traditional sheet music notation is static, printed on paper. With modern computers, the music notation can react to the performer. We call it "interactive visual". Next, we will go through the "what", "how", and "why" of our visual interface design. 
        </p>
        <p class='heading'>
            Interactive Visual Feedback - <b>What</b>
        </p>
        <p>
            Our visual interactivity has two components: <b>The white masks</b> + <b>Offline mistake review</b>. 
        </p>
        <p>
            <b>The white masks</b> show on the screen to represent the notes the performer plays. They overlay on top of the piece's notes. 
        </p>
        <p>
            <b>Offline mistake review</b>. When the player finishes a song, the entire performance history is displayed on the screen as white masks. The tutoring software then offers an option for the player to review the mistakes and toggle the audio between the played version and the ground truth. 
        </p>
        <p class='heading'>
            Interactive Visual Feedback - <b>How</b>
        </p>
        <p>
            Mode A: System leads progression 
        </p>
        <p>
            The playhead moves at a constant speed. White masks are displayed frame by frame, showing the actual performance so that the player can supervise the precise performance timing.
        </p>
        <p>
            Mode B: Performer leads progression
        </p>
        <img src='../assets/demo_irs/cycle.png' alt='The visual interface shows a white mask.' />
        <p>
            The playhead waits for correct performance. If a note is played correctly, it will be outlined with white borders and the playhead jumps to the next note. Otherwise, the playhead does not move and a white mask representing the learner input appears, alongside with a pair of arrows indicating the direction for the player to correct the note.
        </p>
        <p class='heading'>
            Interactive Visual Feedback - <b>Why</b>
        </p>
        <p class='text-center'>
            <img class='wide-img' src='../assets/demo_irs/beforeAfter.png' alt='Two triangles representing before & after. Before: A and M forms a supervisation loop. After: adds another supervisation loop to V and M.' />
        </p>
        </div>
        <div><p class='oneline-p'>
        <span class='iv-backcolor' @click='clickSpan("iv")'>Interactive visual feedback</span>
        improves
        <span class='sp-backcolor' @click='clickSpan("sp")'>sight-playing</span>
        learning rate by 
        <span class='exp-backcolor' @click='clickSpan("exp")'>31.1%</span>.
        </p></div>

        <div class='para-div exp-backcolor' id='exp'>
        <p class='heading'>
            <b>31.1%: Experiment Results</b>
        </p>
        <p>
            Test subjects have no experience with the recorder (a flute-like instrument). Subjects learn to play the recorder through multiple music pieces and we test them to sight-play movel pieces. Learning and testings are repeated for several rounds. Below are the experiment results.
        </p>
        <p>
            <img src='../assets/demo_irs/AvgScore.svg' alt='A plot of average score. The interactive visual feedback group has higher scores' />
        </p>
        <p id='show-img' class='text-center link' @click='showImg'>
            Show more figures
        </p>
        <div id='hidden-img'>
            <p>
            <img src='../assets/demo_irs/super.svg' alt='Another visualization. For explanation please read our paper.' />
            </p>
            <p>
            <img src='../assets/demo_irs/fourXiang.svg' alt='Yet another visualization. For explanation please read our paper.' />
            </p>
            <p id='hide-img' class='text-center link' @click='hideImg'>
            Hide figures
            </p>
        </div>
        </div>
        <p class='text-center'>
        In conclusion, 
        </p>
        <div><p class='oneline-p'>
        <span class='iv-backcolor' @click='clickSpan("iv")'>Interactive visual feedback</span>
        improves
        <span class='sp-backcolor' @click='clickSpan("sp")'>sight-playing</span>
        learning rate by 
        <span class='exp-backcolor' @click='clickSpan("exp")'>31.1%</span>.
        </p></div>

        <p class='text-center'>
        For more information, please read <a href='Interactive Rainbow Score_A Visual-centered Multimodal Flute Tutoring System.pdf'>the paper</a>. 
        </p>
        <br />
	</div>
</template>

<script>
export default {
  name: 'DemoRainbow',
  data() {
    return {
        resourceList:["bibtex","pdf","code","demo"],
        publications:[{name:"",authors:[],year:"",conference:"",bibtex:"",pdf:"",code:"",demo:"",color:[]}],
        sscolor:"#575757",
        groupInfo:[{name:"",
					introPic:"",
					intro:"",
					description:"",
					logan:""
                    }],
        demoInfo:[
            {name:"Interactive Rainbow Score", address:"/demo/IRS"}
        ]
    }
  },
  mounted() {
      this.getGroupInfo()
      
  },
  props: {
    msg: String
  },
  methods: {
    clickSpan:function(id) {
        document.getElementById(id).scrollIntoView({
            behavior: "smooth", 
        });
    },
    showImg:function() {
        const style = document.getElementById('hidden-img').style;
        style.display = 'block';
        setTimeout(() => {
            style.transform = 'scaleX(1)';  
        }, 1);
        document.getElementById('show-img').style.display = 'none';

    },
    hideImg:function() {
        const style = document.getElementById('hidden-img').style;
        style.transform = 'scaleX(0)';  
        setTimeout(() => {
            style.display = 'none';
            document.getElementById('show-img').style.display = 'block';
        }, 400);
    },
    switchToPage:function(url) {
		window.location.href=url
	},
    getGroupInfo:async function() {
        let that = this
        await this.$axios.get("/group/id/list").then(function(res) {
			that.groupInfo = []
			for(let i in res.data) {
				that.groupInfo.push({
					name:res.data[i].name,
					intro:res.data[i].intro,
					introPic:res.data[i].picture,
					description:res.data[i].keywords,
					logan:res.data[i].color
				})
            }
            console.log(that.groupInfo)
		}).catch(function(error) {
			console.log(error)
		})
    }
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
.limit__height__class .v-list__tile {
    height: inherit !important;
}
.limit-logan-offset .v-tooltip__content {
    top:1px !important;
}

.limit-title-offset .v-tooltip__content {
    top:0px !important;
}

body {
  font-family: Heebo-regular, Verdana, Geneva, Tahoma, sans-serif;
  font-size: 18px;
  margin: 0;
}

b {
  font-family: Heebo-bold, Verdana, Geneva, Tahoma, sans-serif;
}

.oneline-p {
  text-align: center;
  line-height: 2;
  font-size: 130%;
}

.oneline-p > span {
  padding: .15rem 5px 0;
  white-space: nowrap;
  cursor: pointer;
  transition: .3s;
  border-bottom: 0.1rem black solid;
}

.iv-backcolor {
  background-color: #e8e8ff;
} .oneline-p >.iv-backcolor:hover {
  background-color: #f0f0ff;
}
.exp-backcolor {
  background-color: #e0ffe0;
} .oneline-p >.exp-backcolor:hover {
  background-color: #f0fff0;
}
.sp-backcolor {
  background-color: #ffe8e8;
} .oneline-p >.sp-backcolor:hover {
  background-color: #fff0f0;
}

.para-div {
  padding: 1px 10px;
}
.para-div > p {
  margin: 1rem auto;
  text-align: justify;
}
@media only screen and (min-width: 400px) {
  .para-div > p {
    width: 70%;
  }
}

.text-center {
  text-align: center !important;
}

img {
  width: 100%;
  max-width: 30rem;
  margin: auto;
  display: block;
}

.wide-img {
  max-width: 100%;
}

.heading {
  font-size: 125%;
}

#hidden-img {
  transform: scaleX(0);
  display: none;
  transition: .4s;
}
.link {
  cursor: pointer;
  text-decoration: underline;
}

.cover {
  padding: 10px;
}

.banner {
  height: 2rem;
  padding: 10px;
  box-shadow: black 0 0 10px 0;
}
.banner img {
  max-height: 100%;
  height: auto;
  width: auto;
}

.banner > a {
  height: 100%;
  transition: .3s;
} .banner > a:hover {
  transform: scale(1.1);
}
.align-left {
  float: left;
}
.align-right {
  float: right;
}
</style>
